import { STOCK_FILTER_OPTIONS } from "@/utils/productFilters.js";
import { formatProductStatus } from "@/utils/format.js";
import { PRODUCT_STATUSES } from "@/utils/constants.js";
import FilterToolboxShell from "@/components/FilterToolboxShell.jsx";

export default function ProductFilterToolbox({
    filters,
    categories,
    lotNames = [],
    showStatus = false,
    showLotName = false,
    showStock = false,
    loading = false,
    onChange,
    onApply,
    onReset
}) {
    const lotNameSuggestions = lotNames.filter((name) => {
        const typed = (filters.lotName || "").trim().toLowerCase();
        if (!typed) {
            return true;
        }
        return name.toLowerCase().includes(typed);
    });

    return (
        <FilterToolboxShell loading={loading} onApply={onApply} onReset={onReset}>
            <label className="field">
                Recherche
                <input
                    type="search"
                    placeholder="Titre ou description"
                    value={filters.search}
                    onChange={(e) => onChange({ ...filters, search: e.target.value })}
                />
            </label>

            <label className="field">
                Catégorie
                <select
                    value={filters.category}
                    onChange={(e) => onChange({ ...filters, category: e.target.value })}
                >
                    <option value="">Toutes</option>
                    {categories.map((category) => (
                        <option key={category} value={category}>{category}</option>
                    ))}
                </select>
            </label>

            {showLotName && (
                <label className="field">
                    Nom du lot
                    <input
                        type="search"
                        list="admin-product-lot-names"
                        placeholder="Ex. Lot initial"
                        value={filters.lotName || ""}
                        onChange={(e) => onChange({ ...filters, lotName: e.target.value })}
                        autoComplete="off"
                    />
                    <datalist id="admin-product-lot-names">
                        {lotNameSuggestions.map((name) => (
                            <option key={name} value={name} />
                        ))}
                    </datalist>
                </label>
            )}

            {showStatus && (
                <label className="field field--status">
                    Statut
                    <select
                        value={filters.status}
                        onChange={(e) => onChange({ ...filters, status: e.target.value })}
                    >
                        <option value="">Tous</option>
                        {PRODUCT_STATUSES.map((status) => (
                            <option key={status} value={status}>{formatProductStatus(status)}</option>
                        ))}
                    </select>
                </label>
            )}

            {showStock && (
                <label className="field field--status">
                    Stock
                    <select
                        value={filters.stock}
                        onChange={(e) => onChange({ ...filters, stock: e.target.value })}
                    >
                        {STOCK_FILTER_OPTIONS.map((option) => (
                            <option key={option.value || "all"} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                </label>
            )}

            <label className="field field--amount">
                Prix min (FCFA)
                <input
                    type="number"
                    min="0"
                    step="1"
                    placeholder="Min"
                    value={filters.priceMin}
                    onChange={(e) => onChange({ ...filters, priceMin: e.target.value })}
                />
            </label>

            <label className="field field--amount">
                Prix max (FCFA)
                <input
                    type="number"
                    min="0"
                    step="1"
                    placeholder="Max"
                    value={filters.priceMax}
                    onChange={(e) => onChange({ ...filters, priceMax: e.target.value })}
                />
            </label>
        </FilterToolboxShell>
    );
}
